import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {icJWT_Account, IncidentRecord, IncidentSearchParams, LabInfo} from "../../NIBINInterface";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {DropdownService} from "../../services/dropdown.service";
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatDialog} from "@angular/material/dialog";
import {NewIncidentFormComponent} from "./new-incident-form/new-incident-form.component";
import {IncidentService} from "../../services/incident.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DialogService} from "../../services/dialog.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.css'],
  providers: [DropdownService, IncidentService]
})
export class IncidentsComponent implements OnInit, AfterViewInit {
  user: icJWT_Account = <icJWT_Account>{};
  @ViewChild("dialog") dialogTarget!: ElementRef;

  dataSource:IncidentRecord[] = [];
  selectIncidents: IncidentRecord[] = []

  constructor(private authService: AuthService,private dropdownService: DropdownService,private incidentService: IncidentService, public dialog: MatDialog, private dialogService: DialogService) {
    this.user = this.authService.getUser()
    this.loadDefaultIncidentData();
  }

  ngOnInit(): void {}
  ngAfterViewInit() {}

  openNewIncidentDialog() {
    let dia = this.dialog.open(NewIncidentFormComponent, {
      width: '80%',
      height: '80%',
      disableClose: true
    })
    dia.backdropClick().subscribe(_ => {

      Swal.fire({
        title: 'Are you sure you want to Close? Any Changes will be lost.',
        showDenyButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor:'darkblue',
        denyButtonText: `No`,
        denyButtonColor:'darkblue',
        timer: 10000,
        timerProgressBar: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          dia.close();
        }
      })

    })
    dia.componentInstance.IncidentCreated.subscribe((val)=>{
      this.incidentService.saveIncToDB(val).then((r)=>{

        if(r?.MessageCode === 200){
          //this.dataSource = [r.AnyData,...this.dataSource]
          this.loadDefaultIncidentData();
          Swal.fire({
            icon: 'success',
            title: 'System Notification',
            text: "Successfully Created Incident Record",
            timerProgressBar:true,
            timer:4000
          })
          dia.close();
        }
        else if(r?.MessageCode === 600) {
          Swal.fire({
            icon: 'error',
            title: 'System Notification',
            text: 'Duplicate Incident Found (Based off Lab, Case #, and Lab #)',
            timerProgressBar:true,
            timer:5000
          })


        }

      });

    })

  }

  async loadDefaultIncidentData():Promise<void> {
    this.dataSource = await this.incidentService.getLatestIncidents(this.user.CurrentDept);
  }

  async searchIncidents(params:IncidentSearchParams): Promise<void> {
    this.dataSource = await this.incidentService.searchIncidents(params);
  }

  SelectedForReport(incident:IncidentRecord) {
    if(this.selectIncidents.indexOf(incident) == -1){
      this.selectIncidents.push(incident)
      incident.SelectedForReport = true
    }
    else {
      this.selectIncidents.splice(this.selectIncidents.indexOf(incident), 1)
      incident.SelectedForReport = false
    }
  }

  RemoveSelectedForReport(incident:IncidentRecord) {
      incident.SelectedForReport=false;
      this.selectIncidents.splice(this.selectIncidents.indexOf(incident),1)
  }

  reload(event: boolean) {
    if(event)
      this.loadDefaultIncidentData()
  }
}
